import React from 'react';
import Blanket from '@atlaskit/blanket';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type CreateDashboardGadgetModal from './main.tsx';
import type { CreateDashboardGadgetModalProps } from './main.tsx';

// We can't migrate this modal to entrypoints yet because entrypoints currently do not support rendering modals
// in legacy pages
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyCreateDashboardGadgetModal = lazy(
	() => import(/* webpackChunkName: "async-create-dashboard-gadget-modal" */ './main'),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({
	onFailed = () => undefined,
	...props
}: JSX.LibraryManagedAttributes<
	typeof CreateDashboardGadgetModal,
	CreateDashboardGadgetModalProps & { onFailed?: () => void }
>) => (
	<JSErrorBoundary
		id="AsyncCreateDashboardGadgetModal"
		packageName="jiraDashboardCreateDashboardGadgetModal"
		fallback="flag"
		onError={onFailed}
	>
		<Placeholder name="async-create-dashboard-gadget-modal" fallback={<Blanket isTinted />}>
			<LazyCreateDashboardGadgetModal {...props} />
		</Placeholder>
	</JSErrorBoundary>
);
